import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=92ee7bb2"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92ee7bb2')) {
      api.createRecord('92ee7bb2', component.options)
    } else {
      api.reload('92ee7bb2', component.options)
    }
    module.hot.accept("./CustomModal.vue?vue&type=template&id=92ee7bb2", function () {
      api.rerender('92ee7bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/shared/CustomModal.vue"
export default component.exports